import React, { useContext, useEffect, useMemo } from 'react'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import UserContext from '../../../../contexts/UserContext'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  PreviewText,
  TableBody,
  HeaderRow,
  HeaderCell,
  ItemRow,
  ItemCell,
  ButtonsDiv,
  CancelButton,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  DisabledNextButtonDiv,
  DisabledNextButtonImage,
  DisabledNextButtonText,
  MappingArea,
  Phrase,
  Preview,
  PreviewContainer,
  RowsDiv,
  RowDiv,
  RowText,
  RowFieldDiv,
  MappingSelect,
  MappingSectionsContainer,
  MappingSection,
  MappingSectionTitle,
  MappingSectionCount,
} from './style'
import StockContext from '../../../../contexts/StockContext'
import axios from '../../../../config/axios'
import ModalContext from '../../../../contexts/ModalContext'
import { useTenant } from '../../../../contexts/TenantContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowRight from '../../../../assets/addStockModal/excel/arrow-right.svg'
import arrowLeft from '../../../../assets/addStockModal/excel/arrow-left.svg'
import disabledArrowRight from '../../../../assets/addStockModal/excel/disabled-arrow-right.svg'
import { autoMapSpreadsheetHeaders } from './utils/normalizeColumnName'
import { dataBaseColumns, resourceDataBaseColumns } from './utils/dataBaseColumns'

interface MappingStepProps {
  isOpen: boolean
  onClose: () => void
}

const MappingStep = () => {
  const { isFashionTenant } = useTenant()
  const { setModalActive, setModalSection, isResourceModal } = useContext(ModalContext)
  const { user } = useContext(UserContext)
  const {
    setActiveTab,
    previewSpreadsheet,
    setPreviewSpreadsheet,
    translationMapping,
    setTranslationMapping,
    manuallyMappedFields,
    setManuallyMappedFields,
    updateInOmie,
    setUpdateInOmie,
    calculateLength,
    setCalculateLength,
    calculateWeight,
    setCalculateWeight,
    defaultMapping,
    setDefaultMapping,
    setReview,
    setLoadingPercentage,
  } = useContext(ImportFromExcelContext)

  const isResource =
    isResourceModal ||
    window.location.pathname.includes('/resource') ||
    (previewSpreadsheet &&
      previewSpreadsheet[0] &&
      Object.values(previewSpreadsheet[0]).some((header: any) => {
        const lower = String(header || '').toLowerCase().trim()
        return lower === 'aviamento' || lower === 'insumo' || lower === 'aviamentos' || lower === 'insumos'
      }))

  const filteredDataBaseColumns = useMemo(() => {
    if (isResource) {
      return resourceDataBaseColumns.map((col) => {
        if (col.value === 'name') {
          return {
            ...col,
            label: isFashionTenant ? 'Aviamento' : 'Insumo',
          }
        }
        return col
      })
    }
    if (!isFashionTenant) {
      return dataBaseColumns.filter(
        (col) =>
          col.value !== 'measurementUnit' &&
          col.value !== 'color' &&
          col.value !== 'totalCost'
      )
    }
    return dataBaseColumns.filter(
      (col) =>
        col.value !== 'heatTreatment' &&
        col.value !== 'density' &&
        col.value !== 'totalCost' &&
        col.value !== 'measurementUnit'
    )
  }, [isResource, isFashionTenant])

  const getColumnWidth = (text1?: string, text2?: string): number => {
    const len1 = (text1 || '').trim().length
    const len2 = (text2 || '').trim().length
    const maxLen = Math.max(len1, len2)
    const calculated = Math.ceil(maxLen * 8.2 + 48)
    return Math.max(80, Math.min(calculated, 360))
  }

  useEffect(() => {
    console.log('MAPPING useEffect executado - translationMapping keys:', Object.keys(translationMapping))
    if (defaultMapping && previewSpreadsheet && previewSpreadsheet[0] && Object.keys(translationMapping).length === 0) {
      const headers = Object.values(previewSpreadsheet[0]) as string[]
      console.log('MAPPING: headers da planilha detectados para auto-mapeamento:', headers)
      const autoMapping = autoMapSpreadsheetHeaders(headers)
      console.log('MAPPING: auto mapping retornado pela funcao:', autoMapping)
      console.log('Aplicando auto mapping porque translationMapping está vazio')
      setTranslationMapping(autoMapping)
    } else if (!defaultMapping) {
      console.log('Limpando translation mapping devido a defaultMapping=false')
      setTranslationMapping({})
    } else {
      console.log('NÃO aplicando auto mapping - translationMapping já tem valores ou condições não atendidas')
    }
  }, [defaultMapping, previewSpreadsheet, translationMapping])

  useEffect(() => {
    console.log('MAPPING COMPONENT MONTADO')
    return () => {
      console.log('MAPPING COMPONENT DESMONTADO')
    }
  }, [])
  const { tableFile, setImportFromExcelModal, setTableFile } =
    useContext(StockContext)

  const spreadsheetHeaders = useMemo(() => {
    if (!previewSpreadsheet || !previewSpreadsheet[0]) return []
    return Object.values(previewSpreadsheet[0]) as string[]
  }, [previewSpreadsheet])

  const { matchedFields, unmatchedSpreadsheet, unmatchedStock } = useMemo(() => {
    console.log('🔄 RECALCULANDO CAMPOS - translationMapping:', Object.keys(translationMapping))
    const matched: { spreadsheetField: string; stockField: string; stockLabel: string }[] = []
    const unmatchedSpreadsheetFields: string[] = []
    const usedStockFields = new Set<string>()

    spreadsheetHeaders.forEach((header) => {
      const mappedValue = translationMapping[header]
      if (mappedValue) {
        const stockColumn = filteredDataBaseColumns.find((col) => col.value === mappedValue)
        matched.push({
          spreadsheetField: header,
          stockField: mappedValue,
          stockLabel: stockColumn?.label || mappedValue,
        })
        usedStockFields.add(mappedValue)
        console.log('✅ CAMPO MATCHED:', header, '->', mappedValue)
      } else {
        unmatchedSpreadsheetFields.push(header)
      }
    })

    const unmatchedStockFields = filteredDataBaseColumns.filter(
      (col) => !usedStockFields.has(col.value)
    )

    console.log('📊 RESULTADO FINAL:')
    console.log('- Matched:', matched.length, 'campos')
    console.log('- Unmatched Spreadsheet:', unmatchedSpreadsheetFields.length, 'campos')
    console.log('- Unmatched Stock:', unmatchedStockFields.length, 'campos')

    const sortedMatched = [...matched].sort((a, b) => {
      const aIndex = manuallyMappedFields.indexOf(a.spreadsheetField)
      const bIndex = manuallyMappedFields.indexOf(b.spreadsheetField)
      const aIsManual = aIndex !== -1
      const bIsManual = bIndex !== -1
      
      if (aIsManual && bIsManual) {
        return bIndex - aIndex
      }
      if (aIsManual && !bIsManual) return -1
      if (!aIsManual && bIsManual) return 1
      return 0
    })

    return {
      matchedFields: sortedMatched,
      unmatchedSpreadsheet: unmatchedSpreadsheetFields,
      unmatchedStock: unmatchedStockFields,
    }
  }, [spreadsheetHeaders, translationMapping, manuallyMappedFields])

  const handleMappingChange = (spreadsheetField: string, stockValue: string) => {
    console.log('🔴 MAPPING CHANGE:', spreadsheetField, '->', stockValue)
    console.log('MAPPING: handleMappingChange chamado', { spreadsheetField, stockValue })
    if (stockValue === '') {
      const newMapping = { ...translationMapping }
      delete newMapping[spreadsheetField]
      setTranslationMapping(newMapping)
      setManuallyMappedFields((prev: string[]) => prev.filter((f) => f !== spreadsheetField))
      console.log('MAPPING: Campo removido', { spreadsheetField })
    } else {
      const newMapping = { ...translationMapping }
      Object.keys(newMapping).forEach((key) => {
        if (newMapping[key] === stockValue) {
          delete newMapping[key]
        }
      })
      newMapping[spreadsheetField] = stockValue
      setTranslationMapping(newMapping)
      setManuallyMappedFields((prev: string[]) => [...prev.filter((f) => f !== spreadsheetField), spreadsheetField])
      console.log('MAPPING: Campo mapeado', { spreadsheetField, stockValue })
    }
  }

  const getSpreadsheetFieldForStock = (stockValue: string): string => {
    const entry = Object.entries(translationMapping).find(([_, value]) => value === stockValue)
    return entry ? entry[0] : ''
  }

  const handleStockFieldChange = (stockValue: string, spreadsheetField: string) => {
    console.log('🔴 STOCK CHANGE:', stockValue, '<-', spreadsheetField)
    console.log('MAPPING: handleStockFieldChange chamado', { stockValue, spreadsheetField })
    if (spreadsheetField === '') {
      const newMapping = { ...translationMapping }
      Object.keys(newMapping).forEach((key) => {
        if (newMapping[key] === stockValue) {
          delete newMapping[key]
          setManuallyMappedFields((prev: string[]) => prev.filter((f) => f !== key))
        }
      })
      setTranslationMapping(newMapping)
      console.log('MAPPING: Mapeamento removido', { stockValue })
    } else {
      const newMapping = { ...translationMapping }
      delete newMapping[spreadsheetField]
      Object.keys(newMapping).forEach((key) => {
        if (newMapping[key] === stockValue) {
          delete newMapping[key]
        }
      })
      newMapping[spreadsheetField] = stockValue
      setTranslationMapping(newMapping)
      setManuallyMappedFields((prev: string[]) => [...prev.filter((f) => f !== spreadsheetField), spreadsheetField])
      console.log('MAPPING: Campo mapeado', { spreadsheetField, stockValue })
    }
  }

  const handleSubmit = () => {
    console.log('MAPPING: handleSubmit chamado')
    console.log('MAPPING: translationMapping sendo enviado:', translationMapping)
    console.log('MAPPING: manuallyMappedFields sendo enviado:', manuallyMappedFields)

    const formData = new FormData()
    formData.append('file', tableFile[0])

    const headers = {
      'Translation-Mapping': JSON.stringify(translationMapping),
      'Update-in-omie': updateInOmie,
      'Weight-calculate': calculateWeight,
      'Length-calculate': calculateLength,
      'Content-Type': 'multipart/form-data',
    }

    axios
      .post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/excel-review`, formData, {
        headers,
      })
      .then((res) => {
        console.log('MAPPING: Resposta do excel-review recebida:', res.data)
        setModalSection('thirdExcelAdd')
        setReview(res.data)
      })
      .catch((err) => {
        console.log('MAPPING: Erro no excel-review:', err)
      })
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie':
        setUpdateInOmie(!updateInOmie)
        break
      case 'defaultMapping':
        setDefaultMapping(!defaultMapping)
        break
      case 'calcLength':
        if (calculateWeight) {
          setCalculateWeight(false)
        }
        setCalculateLength(!calculateLength)
        break
      case 'calcWeight':
        if (calculateLength) {
          setCalculateLength(false)
        }
        setCalculateWeight(!calculateWeight)
        break
      default:
        break
    }
  }

  const handleCancelImport = () => {
    setModalSection('addStockMenu')
    setTableFile(undefined)
    setTranslationMapping({})
    setManuallyMappedFields([])
    setUpdateInOmie(false)
    setDefaultMapping(false)
    setCalculateLength(false)
    setCalculateWeight(false)
    setReview({ missingColumns: [], wrongColumns: [] })
    setImportFromExcelModal(false)
    setLoadingPercentage(0)
  }

  const switches: string[] = [
    'defaultMapping',
    'omie',
    'calcLength',
    'calcWeight',
  ]
  const switchesText: string[] = [
    'Mapeamento padrão',
    'Atualizar produtos na Omie',
    'Calcular comprimentos',
    'Calcular pesos',
  ]
  const switchValues: boolean[] = [
    defaultMapping,
    updateInOmie,
    calculateLength,
    calculateWeight,
  ]

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>
          {isResource
            ? (isFashionTenant ? 'Adicionar aviamento: mapeamento' : 'Adicionar insumo: mapeamento')
            : (isFashionTenant ? 'Adicionar tecido: mapeamento' : 'Importar tabela de estoque: mapeamento')}
        </HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
        <ProgressBarLine />
        <ProgressBarCircle />
      </ProgressBarDiv>
      <Phrase>
        {isResource
          ? (isFashionTenant
              ? 'Especifique a que campo dos nossos aviamentos cada coluna da planilha se relaciona.'
              : 'Especifique a que campo dos nossos insumos cada coluna da planilha se relaciona.')
          : 'Especifique a que campo do nosso estoque cada coluna da planilha se relaciona.'}
      </Phrase>
      {!isFashionTenant && !isResource && (
        <SwitchesDiv>
          {switches.map((field, index) => (
            <SwitchDiv key={field}>
              <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
              <SwitchBox>
                <SwitchInput
                  type='checkbox'
                  name={field}
                  checked={switchValues[index]}
                  onChange={handleSwitchToggle}
                />
                <SwitchSlider className='slider'></SwitchSlider>
              </SwitchBox>
            </SwitchDiv>
          ))}
        </SwitchesDiv>
      )}
      <MappingArea>
        <MappingSectionsContainer>
          <MappingSection>
            <MappingSectionTitle className="matched">
              ✓ Campos combinados
              <MappingSectionCount>{matchedFields.length}</MappingSectionCount>
            </MappingSectionTitle>
            {matchedFields.length > 0 && (
              <RowsDiv>
                <RowDiv>
                  <RowText>Campo da planilha</RowText>
                  <RowFieldDiv>
                    {matchedFields.map((field) => {
                      const colWidth = getColumnWidth(field.spreadsheetField, field.stockLabel)
                      return (
                        <MappingSelect
                          className="custom-select"
                          key={field.spreadsheetField}
                          value={field.spreadsheetField}
                          title={field.spreadsheetField}
                          onChange={() => {}}
                          style={{
                            width: `${colWidth}px`,
                            minWidth: `${colWidth}px`,
                            maxWidth: `${colWidth}px`,
                            flex: `0 0 ${colWidth}px`,
                          }}
                        >
                          <option value={field.spreadsheetField} title={field.spreadsheetField}>
                            {field.spreadsheetField}
                          </option>
                        </MappingSelect>
                      )
                    })}
                  </RowFieldDiv>
                </RowDiv>
                <RowDiv>
                  <RowText>Campo do {isResource ? (isFashionTenant ? 'aviamento' : 'insumo') : 'estoque'}</RowText>
                  <RowFieldDiv>
                    {matchedFields.map((field) => {
                      const colWidth = getColumnWidth(field.spreadsheetField, field.stockLabel)
                      return (
                        <MappingSelect
                          className="custom-select"
                          key={field.spreadsheetField}
                          value={field.stockField}
                          title={field.stockLabel}
                          onChange={(e) => handleMappingChange(field.spreadsheetField, e.target.value)}
                          style={{
                            width: `${colWidth}px`,
                            minWidth: `${colWidth}px`,
                            maxWidth: `${colWidth}px`,
                            flex: `0 0 ${colWidth}px`,
                          }}
                        >
                          <option value="">Remover</option>
                          <option value={field.stockField} title={field.stockLabel}>
                            {field.stockLabel}
                          </option>
                          {unmatchedStock.map((col) => (
                            <option key={col.value} value={col.value} title={col.label}>
                              {col.label}
                            </option>
                          ))}
                        </MappingSelect>
                      )
                    })}
                  </RowFieldDiv>
                </RowDiv>
              </RowsDiv>
            )}
          </MappingSection>

          <MappingSection>
            <MappingSectionTitle className="unmatched-spreadsheet">
              ⚠ Campos da planilha não combinados
              <MappingSectionCount>{unmatchedSpreadsheet.length}</MappingSectionCount>
            </MappingSectionTitle>
            {unmatchedSpreadsheet.length > 0 && (
              <RowsDiv>
                <RowDiv>
                  <RowText>Campo da planilha</RowText>
                  <RowFieldDiv>
                    {unmatchedSpreadsheet.map((header) => {
                      const stockVal = translationMapping[header] || ''
                      const bottomLabel = stockVal
                        ? (filteredDataBaseColumns.find((c) => c.value === stockVal)?.label || stockVal)
                        : 'Selecione'
                      const colWidth = getColumnWidth(header, bottomLabel)
                      return (
                        <MappingSelect
                          className="custom-select"
                          key={header}
                          value={header}
                          title={header}
                          onChange={() => {}}
                          style={{
                            width: `${colWidth}px`,
                            minWidth: `${colWidth}px`,
                            maxWidth: `${colWidth}px`,
                            flex: `0 0 ${colWidth}px`,
                          }}
                        >
                          <option value={header} title={header}>
                            {header}
                          </option>
                        </MappingSelect>
                      )
                    })}
                  </RowFieldDiv>
                </RowDiv>
                <RowDiv>
                  <RowText>Campo do {isResource ? (isFashionTenant ? 'aviamento' : 'insumo') : 'estoque'}</RowText>
                  <RowFieldDiv>
                    {unmatchedSpreadsheet.map((header) => {
                      const stockVal = translationMapping[header] || ''
                      const bottomLabel = stockVal
                        ? (filteredDataBaseColumns.find((c) => c.value === stockVal)?.label || stockVal)
                        : 'Selecione'
                      const colWidth = getColumnWidth(header, bottomLabel)
                      return (
                        <MappingSelect
                          className="custom-select"
                          key={header}
                          value={stockVal}
                          title={bottomLabel}
                          onChange={(e) => handleMappingChange(header, e.target.value)}
                          style={{
                            width: `${colWidth}px`,
                            minWidth: `${colWidth}px`,
                            maxWidth: `${colWidth}px`,
                            flex: `0 0 ${colWidth}px`,
                          }}
                        >
                          <option value="">Selecione</option>
                          {unmatchedStock.map((col) => (
                            <option key={col.value} value={col.value} title={col.label}>
                              {col.label}
                            </option>
                          ))}
                        </MappingSelect>
                      )
                    })}
                  </RowFieldDiv>
                </RowDiv>
              </RowsDiv>
            )}
          </MappingSection>

          <MappingSection>
            <MappingSectionTitle className="unmatched-stock">
              ℹ Campos {isResource ? (isFashionTenant ? 'do aviamento' : 'do insumo') : 'do estoque'} não combinados
              <MappingSectionCount>{unmatchedStock.length}</MappingSectionCount>
            </MappingSectionTitle>
            {unmatchedStock.length > 0 && (
              <RowsDiv>
                <RowDiv>
                  <RowText>Campo da planilha</RowText>
                  <RowFieldDiv>
                    {unmatchedStock.map((col) => {
                      const topValue = getSpreadsheetFieldForStock(col.value)
                      const topLabel = topValue || 'Selecione'
                      const colWidth = getColumnWidth(topLabel, col.label)
                      return (
                        <MappingSelect
                          className="custom-select"
                          key={col.value}
                          value={topValue}
                          title={topLabel}
                          onChange={(e) => handleStockFieldChange(col.value, e.target.value)}
                          style={{
                            width: `${colWidth}px`,
                            minWidth: `${colWidth}px`,
                            maxWidth: `${colWidth}px`,
                            flex: `0 0 ${colWidth}px`,
                          }}
                        >
                          <option value="">Selecione</option>
                          {unmatchedSpreadsheet.map((header) => (
                            <option key={header} value={header} title={header}>
                              {header}
                            </option>
                          ))}
                        </MappingSelect>
                      )
                    })}
                  </RowFieldDiv>
                </RowDiv>
                <RowDiv>
                  <RowText>Campo do {isResource ? (isFashionTenant ? 'aviamento' : 'insumo') : 'estoque'}</RowText>
                  <RowFieldDiv>
                    {unmatchedStock.map((col) => {
                      const topValue = getSpreadsheetFieldForStock(col.value)
                      const topLabel = topValue || 'Selecione'
                      const colWidth = getColumnWidth(topLabel, col.label)
                      return (
                        <MappingSelect
                          className="custom-select"
                          key={col.value}
                          value={col.value}
                          title={col.label}
                          onChange={() => {}}
                          style={{
                            width: `${colWidth}px`,
                            minWidth: `${colWidth}px`,
                            maxWidth: `${colWidth}px`,
                            flex: `0 0 ${colWidth}px`,
                          }}
                        >
                          <option value={col.value} title={col.label}>
                            {col.label}
                          </option>
                        </MappingSelect>
                      )
                    })}
                  </RowFieldDiv>
                </RowDiv>
              </RowsDiv>
            )}
          </MappingSection>
        </MappingSectionsContainer>

        <PreviewText>Preview</PreviewText>
        <PreviewContainer>
          <Preview>
            <TableBody>
              {previewSpreadsheet && previewSpreadsheet.length > 0 && (
                <>
                  <HeaderRow>
                    {Object.keys(previewSpreadsheet[0]).map((key, colIndex) => (
                      <HeaderCell
                        key={colIndex}
                        title={previewSpreadsheet[0][key] || key}
                      >
                        {previewSpreadsheet[0][key] || key}
                      </HeaderCell>
                    ))}
                  </HeaderRow>
                  {previewSpreadsheet.slice(1).map((item, rowIndex) => (
                    <ItemRow key={rowIndex}>
                      {Object.keys(previewSpreadsheet[0]).map((key, colIndex) => {
                        const cellValue = item[key]
                        const displayValue =
                          cellValue !== null &&
                          cellValue !== undefined &&
                          String(cellValue).trim() !== ''
                            ? String(cellValue)
                            : '-'
                        return (
                          <ItemCell
                            key={colIndex}
                            title={displayValue !== '-' ? displayValue : undefined}
                          >
                            {displayValue}
                          </ItemCell>
                        )
                      })}
                    </ItemRow>
                  ))}
                </>
              )}
            </TableBody>
          </Preview>
        </PreviewContainer>
      </MappingArea>
      <ButtonsDiv>
        <CancelButton onClick={() => handleCancelImport()}>
          Cancelar
        </CancelButton>
        <PreviousButtonDiv onClick={() => setModalSection('firstExcelAdd')}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        {Object.keys(translationMapping).length === 0 ? (
          <DisabledNextButtonDiv>
            <DisabledNextButtonImage
              src={disabledArrowRight}
              alt='Right arrow icon'
            />
            <DisabledNextButtonText>Próximo</DisabledNextButtonText>
          </DisabledNextButtonDiv>
        ) : (
          <NextButtonDiv onClick={() => handleSubmit()}>
            <NextButtonImage src={arrowRight} alt='Right arrow icon' />
            <NextButtonText>Próximo</NextButtonText>
          </NextButtonDiv>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default MappingStep

